import Vue from 'vue';
import Router from 'vue-router';

import Main from '@/views/Main.vue';
import DealersView from '@/components/sections/dealers/DealersView.vue';
import AccessoriesView from '@/components/sections/accessories/AccessoriesView.vue';
import InspectionsView from '@/components/sections/inspections/InspectionsView.vue';
import AssistantsView from '@/components/sections/assistants/AssistantsView.vue';
import IndicatorsView from '@/components/sections/indicators/IndicatorsView.vue';
import ModelsView from '@/components/sections/models/ModelsView.vue';
import BannerView from '@/components/sections/banner/BannerItem.vue';
import RssView from '@/components/sections/rss/RssView.vue';
import PlusView from '@/components/sections/plus/PlusView';

import store from '@/store';

import authGuard from '@/util/auth-guard';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  beforeEnter: authGuard,
  routes: [
    {
      path: '/',
      redirect: '/dealers/all',
      component: Main,
      children: [
        {
          name: 'dealers',
          path: '/dealers',
          redirect: '/dealers/all',
          component: DealersView,
          children: [
            {
              path: 'all',
              meta: {
                tableType: 'all',
                showDeleted: false,
              },
            },
            {
              path: 'deleted',
              meta: {
                tableType: 'deleted',
                showDeleted: true,
              },
            },
            {
              path: 'cities',
              meta: {
                tableType: 'cities',
                showDeleted: false,
              },
            },
          ],
        },
        {
          name: 'accessories',
          path: '/accessories',
          component: AccessoriesView,
          children: [
            {
              name: 'all',
              path: 'all',
            },
          ],
        },
        {
          name: 'assistants',
          path: '/assistants',
          redirect: '/assistants/all',
          component: AssistantsView,
          children: [
            {
              name: 'assistants-all',
              path: 'all',
              meta: {
                tableType: 'all',
                showDeleted: false,
              },
            },
          ],
        },
        {
          name: 'indicators',
          path: '/indicators',
          redirect: '/indicators/all',
          component: IndicatorsView,
          children: [
            {
              name: 'indicators-all',
              path: 'all',
              meta: {
                tableType: 'all',
                showDeleted: false,
              },
            },
          ],
        },
        {
          name: 'models',
          path: '/models',
          redirect: '/models/all',
          component: ModelsView,
          children: [
            {
              name: 'models-all',
              path: 'all',
              meta: {
                tableType: 'all',
                showDeleted: false,
              },
            },
          ],
        },
        {
          name: 'banner',
          path: '/banner',
          component: BannerView,
        },
        {
          name: 'rss',
          path: '/rss',
          redirect: '/rss/audi',
          component: RssView,
          children: [
            {
              name: 'rss-audi',
              path: 'audi',
              meta: {
                tableType: 'audi',
                showDeleted: false,
              },
            },
            {
              name: 'rss-service',
              path: 'service',
              meta: {
                tableType: 'service',
                showDeleted: false,
              },
            },
          ],
        },
        {
          name: 'new-dealer',
          path: '/dealers/new',
          props: {
            createMode: true,
          },
          component: () => import('@/components/sections/dealers/DealersItem.vue'),
        },
        {
          name: 'assistants-new',
          path: '/assistants/new',
          props: {
            createMode: true,
          },
          component: () => import('@/components/sections/assistants/AssistantsItem.vue'),
        },
        {
          name: 'indicators-new',
          path: '/indicators/new',
          props: {
            createMode: true,
          },
          component: () => import('@/components/sections/indicators/IndicatorsItem.vue'),
        },
        {
          name: 'accessories-new',
          path: '/accessories/new',
          props: {
            createMode: true,
          },
          component: () => import('@/components/sections/accessories/AccessoriesItem.vue'),
        },
        {
          name: 'accessory-category-new',
          path: '/accessories/categories/new',
          props: {
            createMode: true,
          },
          component: () => import('@/components/sections/accessories/AccessoryCategoryItem.vue'),
        },
        {
          name: 'dealers-item',
          path: '/dealers/:id',
          props: {
            createMode: false,
          },
          component: () => import('@/components/sections/dealers/DealersItem.vue'),
        },
        {
          name: 'assistants-item',
          path: '/assistants/:id',
          props: {
            createMode: false,
          },
          component: () => import('@/components/sections/assistants/AssistantsItem.vue'),
        },
        {
          name: 'indicators-item',
          path: '/indicators/:id',
          props: {
            createMode: false,
          },
          component: () => import('@/components/sections/indicators/IndicatorsItem.vue'),
        },
        {
          name: 'accessories-item',
          path: 'accessories/:id',
          props: {
            createMode: false,
          },
          component: () => import('@/components/sections/accessories/AccessoriesItem.vue'),
        },
        {
          name: 'accessory-category-item',
          path: 'accessory/categories/:id',
          props: {
            createMode: false,
          },
          component: () => import('@/components/sections/accessories/AccessoryCategoryItem.vue'),
        },
        {
          name: 'inspections',
          path: '/inspections',
          redirect: '/inspections/all',
          component: InspectionsView,
          children: [
            {
              name: 'inspections-all',
              path: 'all',
              meta: {
                tableType: 'all',
                showDeleted: false,
              },
            },
          ],
        },
        {
          name: 'plus',
          path: '/plus',
          redirect: '/plus/all',
          component: PlusView,
          children: [
            {
              path: 'all',
              meta: {
                tableType: 'all',
                showDeleted: false,
              },
            }
          ],
        },
        {
          name: 'plus-new',
          path: '/plus/new',
          props: {
            createMode: true,
          },
          component: () => import('@/components/sections/plus/PlusItem.vue'),
        },
      ],
    },
    {
      name: 'login',
      path: '/login',
      beforeEnter: (to, from, next) => {
        store.dispatch('user/logout', false);
        next();
      },
      component: () => import('@/views/Login.vue'),
    },
    {
      name: 'logout',
      path: '/logout',
      beforeEnter: (to, from, next) => {
        store.dispatch('user/logout', false);
        next({ name: 'login' });
      },
    },
    {
      name: 'forbidden',
      path: '/forbidden',
      component: () => import('@/views/Forbidden.vue')
    },
    {
      name: 'auth-callback',
      path: '/auth-callback',
      component: () => import('@/views/AuthCallback.vue'),
    },
  ],
});
